import Layout from '@/layout'

const inquiryRouter = {
    path: '/inquiry',
    component: Layout,
    meta: {
        title: '我要查询'
    },
    children: [
        {
            path: '',
            name: 'Inquiry',
            component: () => import('@/views/inquiry/index')
        }
    ]
}

const InquiryQrcodeRouter = {
    path: '/inquiry/result',
    name: 'InquiryResult',
    component: () => import('@/views/inquiry/result/index')
}

export {
    inquiryRouter,
    InquiryQrcodeRouter
}